export default class Emergency {
  id = null;
  emergencyStart = '';
  emergencyStop = '';
  createdAt = '';
  lang = '';
  status = false;
  elevator = null;

  constructor() {
  }

}